import DOMController from "./abstract/DOMController";

/**
 * Настройки через data-атрибуты:
 * @attr boolean data-use-fade      - true для использования затенения по краям скролла
 * @attr int     data-init-position - смещение в процентах от ширины блока. При параметре, равном "50",
 *                                    блок при инициализации будет прокручен к середине, "100" - к правому краю
 */
export class Scroller extends DOMController
{
    protected elements: NodeListOf<Element>;
    protected classes = {
        fadeLeft: 'scroller_fade-left',
        fadeRight: 'scroller_fade-right',
        content: 'scroller__content',
    };

    /**
     * @param elements - набор узлов или css-селектор
     */
    public constructor(elements: NodeListOf<Element>|string)
    {
        super();

        if (typeof elements === 'string') {
            elements = document.querySelectorAll(elements);
        }

        if (elements.length === 0) {
            return;
        }

        this.elements = elements;

        this.init();
        this.appendEventListeners();
    }

    public scrollPercent(scroller: Element, percent: number)
    {
        this.scrollTo(scroller, percent, true);
    }

    public scroll(scroller: Element, value: number)
    {
        this.scrollTo(scroller, value, false);
    }

    protected scrollTo(scroller: Element, value: number, isPercent: boolean = false)
    {
        let content = scroller.getElementsByClassName(this.classes.content).item(0);
        let maxScrollPosition = content.scrollWidth - content.clientWidth;

        if (maxScrollPosition <= 0) { // visible viewport more than scrollable content width. Nothing to scroll
            return;
        }

        if (isPercent) {
            value = Math.round(maxScrollPosition * value / 100);
        }

        content.scrollTo(Math.abs(value), 0);
    }

    protected init()
    {
        this.elements.forEach(scroller => {
            this.visualizePosition(scroller);

            let initPosition = Number(scroller.getAttribute('data-init-position'));

            if (!isNaN(initPosition)) {
                this.scrollTo(scroller, Math.abs(initPosition), true);
            }
        });
    }

    protected appendEventListeners()
    {
        this.elements.forEach(scroller => {
            this.getContent(scroller).addEventListener('scroll', () => {
                this.visualizePosition(scroller);
            });
        });
    }

    /**
     * Добавление/удаление визуальных эффектов при прокрутке
     */
    protected visualizePosition(scroller: Element)
    {
        let content = this.getContent(scroller);

        if (content.scrollWidth <= content.clientWidth) {
            scroller.classList.remove(this.classes.fadeLeft, this.classes.fadeRight);
            return;
        }

        if (scroller.getAttribute('data-use-fade') === 'true') {
            if (content.scrollLeft > 0) {
                scroller.classList.add(this.classes.fadeLeft);
            } else {
                scroller.classList.remove(this.classes.fadeLeft);
            }

            if (content.scrollLeft + content.clientWidth < content.scrollWidth) {
                scroller.classList.add(this.classes.fadeRight);
            } else {
                scroller.classList.remove(this.classes.fadeRight);
            }
        }
    }

    protected getContent(scroller: Element): Element|null
    {
        let content = scroller.querySelector('.' + this.classes.content)

        if (!content) {
            console.error('Scroller has no content');
        }

        return content;
    }
}
